import { defineComponent as i, openBlock as n, createElementBlock as c, createElementVNode as e, createVNode as t, unref as s, toDisplayString as o } from "vue";
import r from "../../icons/generated/IconSunBeam.vue2.js";
import l from "../../icons/generated/IconSunFace.vue2.js";
const m = {
  "aria-busy": "true",
  "aria-live": "polite",
  class: "text-static-default-hi heading-3 flex flex-col items-center justify-center text-center"
}, f = { class: "relative mb-32 flex size-96" }, d = { class: "flex w-full items-center justify-center" }, v = /* @__PURE__ */ i({
  name: "RevLoadingScreen",
  __name: "LoadingScreen",
  props: {
    text: {}
  },
  setup(a) {
    return (u, _) => (n(), c("div", m, [
      e("div", f, [
        e("div", d, [
          t(s(l), {
            class: "absolute size-60",
            "data-test": "icon-sun-face"
          })
        ]),
        t(s(r), {
          class: "absolute size-96 animate-spin-slow",
          "data-test": "icon-sun-beam"
        })
      ]),
      e("h3", null, o(a.text), 1)
    ]));
  }
});
export {
  v as default
};
